package com.evoapps.evoshift

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.MotionVisibility
import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.ui.user.ClockReviewCard
import com.evoapps.evoshift.viewmodels.ClockReviewViewModel
import com.evoapps.evoshift.push.DeviceTokenSync
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.ui.input.key.onKeyEvent
import com.evoapps.evoshift.navigation.AppShortcuts
import com.evoapps.evoshift.navigation.AppShortcut
import com.evoapps.evoshift.navigation.KeyboardShortcuts
import com.evoapps.evoshift.navigation.LocalAppShortcuts
import com.evoapps.evoshift.navigation.fullScreenRoutes
import com.evoapps.evoshift.navigation.shortcutHelp
import androidx.compose.foundation.layout.navigationBarsPadding
import com.evoapps.evoshift.domain.model.isReadOnly
import com.evoapps.evoshift.ui.billing.PlanEndedBanner
import com.evoapps.evoshift.ui.billing.OverPlanBanner
import com.evoapps.evoshift.viewmodels.OverPlanViewModel
import kotlinx.datetime.number
import kotlinx.datetime.LocalDate
import com.evoapps.evoshift.domain.usecase.AtWorkEntry
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.TimeZone
import com.evoapps.evoshift.domain.model.currentOrNearest
import androidx.compose.animation.AnimatedContentTransitionScope
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.ExperimentalSharedTransitionApi
import androidx.compose.animation.SharedTransitionLayout
import androidx.compose.animation.expandVertically
import androidx.compose.animation.shrinkVertically
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.consumeWindowInsets
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationBarDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.rememberUpdatedState
import com.evoapps.evoshift.shell.AppCommand
import com.evoapps.evoshift.shell.LocalAppShell
import com.evoapps.evoshift.saves.LocalPendingSaves
import com.evoapps.evoshift.saves.PendingSaves
import com.evoapps.evoshift.saves.SaveNoticesHost
import com.evoapps.evoshift.shell.ShellState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.remember
import com.evoapps.evoshift.ui.theme.LocalSharedTransitionScope
import com.evoapps.evoshift.ui.theme.NavEntryTabs
import com.evoapps.evoshift.ui.theme.NavMotion
import androidx.navigation.NavBackStackEntry
import com.evoapps.evoshift.ui.theme.enterFor
import com.evoapps.evoshift.ui.theme.exitFor
import com.evoapps.evoshift.ui.theme.navMotion
import com.evoapps.evoshift.ui.theme.prefersReducedMotion
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.draw.clipToBounds
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.navigation.NavDestination.Companion.hasRoute
import androidx.navigation.compose.NavHost
import com.evoapps.evoshift.navigation.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import androidx.navigation.compose.rememberNavController
import androidx.navigation.toRoute
import com.evoapps.evoshift.di.appModule
import com.evoapps.evoshift.di.diViewModel
import com.evoapps.evoshift.domain.model.Capability
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.domain.model.RosterStatus
import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.model.capabilitiesAt
import com.evoapps.evoshift.domain.usecase.billing.ResetBillingIdentityUseCase
import com.evoapps.evoshift.navigation.AppNavigationBar
import com.evoapps.evoshift.navigation.AppNavigationRail
import com.evoapps.evoshift.navigation.RailWindowInsets
import com.evoapps.evoshift.navigation.AppTab
import com.evoapps.evoshift.navigation.BindBrowserBack
import com.evoapps.evoshift.navigation.DetailPanes
import com.evoapps.evoshift.ui.adaptive.PaneViewModelStore
import com.evoapps.evoshift.navigation.DeepLinks
import com.evoapps.evoshift.ui.voice.VoiceActionScreen
import com.evoapps.evoshift.navigation.LinkPlacement
import com.evoapps.evoshift.navigation.MoreEntry
import com.evoapps.evoshift.navigation.NavChrome
import com.evoapps.evoshift.navigation.SessionGate
import com.evoapps.evoshift.navigation.canOpen
import com.evoapps.evoshift.navigation.forgetTabStacks
import com.evoapps.evoshift.navigation.goHome
import com.evoapps.evoshift.navigation.leaveWorkplaceScreens
import com.evoapps.evoshift.navigation.linkPlacement
import com.evoapps.evoshift.navigation.moreEntriesFor
import com.evoapps.evoshift.navigation.mustLeaveForHome
import com.evoapps.evoshift.navigation.navChromeFor
import com.evoapps.evoshift.navigation.darkNavigationIconsFor
import com.evoapps.evoshift.navigation.darkStatusIconsFor
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.adaptive.SystemBarIcons
import com.evoapps.evoshift.navigation.open
import com.evoapps.evoshift.navigation.openAsRoot
import com.evoapps.evoshift.navigation.openOnce
import com.evoapps.evoshift.navigation.route
import com.evoapps.evoshift.navigation.signedIn
import com.evoapps.evoshift.navigation.routeClasses
import com.evoapps.evoshift.navigation.selectTab
import com.evoapps.evoshift.navigation.selectedTab
import com.evoapps.evoshift.navigation.startRoute
import com.evoapps.evoshift.navigation.tabsFor
import com.evoapps.evoshift.navigation.tabBadges
import com.evoapps.evoshift.session.WorkplaceSessionManager
import com.evoapps.evoshift.session.WorkplaceMonthSelection
import com.evoapps.evoshift.session.of
import com.evoapps.evoshift.session.yearMonth
import com.evoapps.evoshift.navigation.KnownRosters
import com.evoapps.evoshift.navigation.RosterMonthHost
import com.evoapps.evoshift.ui.roster.NoRosterForMonth
import com.evoapps.evoshift.widgets.LocalNavyTopBars
import com.evoapps.evoshift.widgets.LocalTopBarSelection
import com.evoapps.evoshift.widgets.NavyTopBars
import com.evoapps.evoshift.widgets.TopBarSelection
import evoshift.composeapp.generated.resources.daily_records_title
import evoshift.composeapp.generated.resources.capacity_title
import evoshift.composeapp.generated.resources.payroll_title
import evoshift.composeapp.generated.resources.availability_my_availability
import evoshift.composeapp.generated.resources.top_bar_no_availability_request
import com.evoapps.evoshift.ui.util.monthName
import kotlinx.datetime.YearMonth
import com.evoapps.evoshift.observability.AnalyticsEvent
import com.evoapps.evoshift.observability.Telemetry
import com.evoapps.evoshift.ui.legal.PrivacyConsentSheet
import com.evoapps.evoshift.viewmodels.PrivacyChoicesViewModel
import com.evoapps.evoshift.ui.AppTheme
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.ProvideWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.LocalDevicePosture
import com.evoapps.evoshift.ui.adaptive.LocalDevicePostureOverride
import com.evoapps.evoshift.ui.adaptive.isTabletop
import com.evoapps.evoshift.ui.adaptive.rememberPlatformDevicePosture
import com.evoapps.evoshift.ui.user.NotificationSettingsScreen
import com.evoapps.evoshift.ui.checklists.AtWorkChecklists
import com.evoapps.evoshift.ui.checklists.ChecklistsScreen
import com.evoapps.evoshift.ui.checklists.MyChecklistsCard
import com.evoapps.evoshift.ui.checklists.ShiftChecklistScreen
import com.evoapps.evoshift.viewmodels.ChecklistsViewModel
import com.evoapps.evoshift.viewmodels.MyChecklistsViewModel
import com.evoapps.evoshift.viewmodels.ShiftChecklistViewModel
import com.evoapps.evoshift.viewmodels.TodayChecklistsViewModel
import com.evoapps.evoshift.viewmodels.NotificationSettingsViewModel
import com.evoapps.evoshift.ui.billing.OwnerPlanEntry
import com.evoapps.evoshift.ui.billing.PaywallScreen
import com.evoapps.evoshift.ui.billing.SubscriptionScreen
import com.evoapps.evoshift.ui.finance.DailyRecordsScreen
import com.evoapps.evoshift.ui.finance.PayrollScreen
import com.evoapps.evoshift.ui.join.JoinTeamScreen
import com.evoapps.evoshift.ui.login.AuthScreen
import com.evoapps.evoshift.ui.more.MoreScreen
import com.evoapps.evoshift.ui.notifications.LocalOpenNotifications
import com.evoapps.evoshift.ui.notifications.ShellNotifications
import com.evoapps.evoshift.ui.notifications.destinationFor
import com.evoapps.evoshift.ui.notifications.NotificationsScreen
import com.evoapps.evoshift.ui.onboarding.OnboardingScreen
import com.evoapps.evoshift.ui.roster.CreateRosterScreen
import com.evoapps.evoshift.ui.roster.RosterBuilderScreen
import com.evoapps.evoshift.ui.roster.RosterManagementScreen
import com.evoapps.evoshift.ui.roster.RosterCapacityScreen
import com.evoapps.evoshift.ui.roster.RosterSkeletonScreen
import com.evoapps.evoshift.ui.user.AbsencesScreen
import com.evoapps.evoshift.ui.user.LeaveBalancesScreen
import com.evoapps.evoshift.ui.tips.TipsScreen
import com.evoapps.evoshift.viewmodels.TipsViewModel
import com.evoapps.evoshift.viewmodels.LeaveBalancesViewModel
import com.evoapps.evoshift.ui.user.AvailabilityFormScreen
import com.evoapps.evoshift.ui.user.AvailabilityScreen
import com.evoapps.evoshift.ui.user.DashboardScreen
import com.evoapps.evoshift.ui.user.EmployeeDashboardScreen
import com.evoapps.evoshift.ui.user.EmployeeFormScreen
import com.evoapps.evoshift.ui.user.FinancialsScreen
import com.evoapps.evoshift.ui.user.ManagerDashboardScreen
import com.evoapps.evoshift.ui.user.OwnerDashboardScreen
import com.evoapps.evoshift.ui.user.ProfileScreen
import com.evoapps.evoshift.ui.user.RecurringCostRulesScreen
import com.evoapps.evoshift.ui.user.RequestsScreen
import com.evoapps.evoshift.ui.user.ScheduleScreen
import com.evoapps.evoshift.ui.user.TeamManagementScreen
import com.evoapps.evoshift.ui.user.WeeklyTemplatesScreen
import com.evoapps.evoshift.ui.workplaces.CreateWorkplaceScreen
import com.evoapps.evoshift.ui.workplaces.SkeletonEditorScreen
import com.evoapps.evoshift.ui.workplaces.WorkplaceSettingsScreen
import com.evoapps.evoshift.viewmodels.AbsencesViewModel
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.viewmodels.AuthViewModel
import com.evoapps.evoshift.viewmodels.AvailabilityFormViewModel
import com.evoapps.evoshift.viewmodels.AvailabilityViewModel
import com.evoapps.evoshift.viewmodels.CreateRosterViewModel
import com.evoapps.evoshift.viewmodels.DailyRecordsViewModel
import com.evoapps.evoshift.viewmodels.DashboardEvent
import com.evoapps.evoshift.viewmodels.DashboardViewModel
import com.evoapps.evoshift.viewmodels.EmployeeDashboardViewModel
import com.evoapps.evoshift.viewmodels.EmployeeFormViewModel
import com.evoapps.evoshift.viewmodels.JoinTeamViewModel
import com.evoapps.evoshift.viewmodels.ManagerDashboardViewModel
import com.evoapps.evoshift.viewmodels.NotificationsViewModel
import com.evoapps.evoshift.viewmodels.OnboardingViewModel
import com.evoapps.evoshift.viewmodels.OwnerDashboardViewModel
import com.evoapps.evoshift.viewmodels.PayrollViewModel
import com.evoapps.evoshift.viewmodels.RosterCapacityViewModel
import com.evoapps.evoshift.viewmodels.PlanChoiceViewModel
import com.evoapps.evoshift.viewmodels.ProfileViewModel
import com.evoapps.evoshift.viewmodels.RecurringCostRulesViewModel
import com.evoapps.evoshift.viewmodels.SalesImportViewModel
import com.evoapps.evoshift.ui.finance.SalesImportScreen
import com.evoapps.evoshift.viewmodels.RequestsViewModel
import com.evoapps.evoshift.viewmodels.RootState
import com.evoapps.evoshift.viewmodels.RootViewModel
import com.evoapps.evoshift.util.SecureScreenEffect
import com.evoapps.evoshift.navigation.SecureScreens
import com.evoapps.evoshift.viewmodels.RosterDetailViewModel
import com.evoapps.evoshift.viewmodels.RosterSkeletonViewModel
import com.evoapps.evoshift.viewmodels.ScheduleViewModel
import com.evoapps.evoshift.viewmodels.SkeletonEditorViewModel
import com.evoapps.evoshift.viewmodels.SubscriptionViewModel
import com.evoapps.evoshift.viewmodels.TeamManagementViewModel
import com.evoapps.evoshift.viewmodels.WeeklyTemplatesViewModel
import com.evoapps.evoshift.viewmodels.WorkplaceCreationViewModel
import com.evoapps.evoshift.viewmodels.WorkplaceSettingsViewModel
import com.evoapps.evoshift.widget.ShiftWidgetSync
import com.evoapps.evoshift.widgets.ContextSwitchBottomSheet
import com.evoapps.evoshift.widgets.ContextSwitcher
import com.evoapps.evoshift.widgets.LocalContextSwitcher
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.workplace
import evoshift.composeapp.generated.resources.app_logo
import evoshift.composeapp.generated.resources.join_pending_hint
import evoshift.composeapp.generated.resources.join_team_invited
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.kodein.di.compose.rememberInstance
import com.evoapps.evoshift.connectivity.connectionNotices
import org.kodein.di.compose.withDI
import com.evoapps.evoshift.salesimport.IncomingSalesFiles
import com.evoapps.evoshift.salesimport.salesImportWorkplaces
import com.evoapps.evoshift.ui.finance.IncomingSalesFileDialog
import com.evoapps.evoshift.di.AppWindowScope
import com.evoapps.evoshift.shell.LocalWindowTarget
import com.evoapps.evoshift.shell.WindowTarget
import com.evoapps.evoshift.widgets.dismissKeyboardOnTapOutside

/**
 * The app. [window]: SH-161 F3, a window of its own ("Open in new window", Android) on that
 * workplace or roster, with its own session and view models ([AppWindowScope]); null: the main
 * window, the one links and shared files reach.
 */
@Composable
fun App(window: WindowTarget? = null) {
    val di = if (window == null) appModule else androidx.lifecycle.viewmodel.compose.viewModel(key = "window:$window") { AppWindowScope(window) }.di
    withDI(di) {
      CompositionLocalProvider(LocalWindowTarget provides window) {
        // SH-196: the colours remembered on this device, before the first frame.
        com.evoapps.evoshift.settings.ApplyRememberedAppearance()
        AppTheme {
            // SH-198: whatever no screen draws (between screens in a transition) is the app's
            // background, never the host's black: under the shell here and on iOS the hosting
            // view too.
            val background = MaterialTheme.colorScheme.background
            com.evoapps.evoshift.ui.adaptive.HostBackground(background)
            // SH-249: Done on the iOS number pads, and a tap on nothing puts the keyboard away.
            com.evoapps.evoshift.widgets.ProvideKeyboardDismiss {
                Box(
                    Modifier
                        .fillMaxSize()
                        .background(background)
                        .dismissKeyboardOnTapOutside()
                ) {
                    AdaptiveAppLayout()
                }
            }
        }
      }
    }
}

/** What the app may show for [this] sign-in state. */
private fun RootState.LoggedIn.gate(): SessionGate = when {
    !isEmailVerified -> SessionGate.UNVERIFIED
    !isSetupComplete -> SessionGate.NEEDS_ONBOARDING
    else -> SessionGate.READY
}

/**
 * What the person may do at the current workplace: nothing once the engagement ended. The same
 * as `DashboardUiState.capabilities` (SH-41 UI gating); once both are merged, read it there.
 */
private fun currentCapabilities(user: User?, workplaceId: String?): Set<Capability> =
    user?.capabilitiesAt(workplaceId).orEmpty()

/** SH-146: owners and managers get the managers' notes, everyone else the employees'. */
private fun whatsNewForManager(user: User?, workplaceId: String?): Boolean {
    val engagement = workplaceId?.let { user?.engagements?.get(it) }
        ?: user?.engagements?.values?.firstOrNull { it.isActive }
    return engagement != null && engagement.permission != com.evoapps.evoshift.domain.model.UserPermission.EMPLOYEE
}

private fun RootState.gate(): SessionGate = (this as? RootState.LoggedIn)?.gate() ?: SessionGate.SIGNED_OUT

/**
 * The app's shell (SH-42, as EVoLabels' MainShell): one bar for the whole app, owned here (screens
 * know nothing about it). Tabs by role ([tabsFor]); the bar on sections only, the rail on wide
 * screens everywhere; each tab keeps its stack, reselecting returns to its root, back from a tab
 * returns home. Links wait in [DeepLinks] until the person can see them.
 */
@Composable
fun AdaptiveAppLayout() {
    // SH-137: the whole app in the language picked in the app; a new pick switches it at once.
    com.evoapps.evoshift.settings.ProvideAppLanguage {
        // SH-158: the system's reduced motion (or a test's) for every animation in the app, and
        // the haptics actions answer with.
        CompositionLocalProvider(
            com.evoapps.evoshift.ui.theme.LocalReducedMotion provides
                (com.evoapps.evoshift.ui.theme.LocalReducedMotion.current || prefersReducedMotion()),
            com.evoapps.evoshift.widgets.LocalActionFeedback provides com.evoapps.evoshift.widgets.rememberActionFeedback()
        ) {
            AppLayout()
            // SH-161 F4: "Save as…" or "Share" for this window's exports (Android).
            com.evoapps.evoshift.ui.reports.ExportChoiceHost()
        }
    }
}

@OptIn(ExperimentalSharedTransitionApi::class)
@Composable
private fun AppLayout() {
    val rootViewModel: RootViewModel = diViewModel()
    // SH-146: decided when the app starts (a first install never sees it), shown once signed in.
    val whatsNewViewModel: com.evoapps.evoshift.viewmodels.WhatsNewViewModel = diViewModel()
    val rootState by rootViewModel.state.collectAsState()
    // SH-161 F3: a window of its own opens on its workplace or roster; links, shared files and the
    // app-wide background work stay with the main window.
    val window = LocalWindowTarget.current

    if (window == null) {
        // Keeps the home-screen widget's snapshot current while the app runs (Android; no-op elsewhere).
        val widgetSync: ShiftWidgetSync by rememberInstance()
        LaunchedEffect(widgetSync) { widgetSync.start(this) }
        // The push token with the app's current language, so pushes come in it (SH-109).
        val deviceTokenSync: DeviceTokenSync by rememberInstance()
        LaunchedEffect(deviceTokenSync) { deviceTokenSync.start(this) }
        // SH-240: counts this start (the first never asks for a store rating) and listens for success moments.
        val reviewPrompter: com.evoapps.evoshift.review.ReviewPrompter by rememberInstance()
        LaunchedEffect(reviewPrompter) { reviewPrompter.start() }
    }

    val dashboardViewModel: DashboardViewModel by rememberInstance()
    val dashboardState by dashboardViewModel.uiState.collectAsStateWithLifecycle()
    // SH-148: saves run to completion in the app's scope; the top bar shows them, the shell reports them.
    val pendingSaves: PendingSaves by rememberInstance()
    val notificationsViewModel: NotificationsViewModel by rememberInstance()
    val notificationsState by notificationsViewModel.uiState.collectAsStateWithLifecycle()
    val pendingRequestsViewModel: com.evoapps.evoshift.viewmodels.PendingRequestsViewModel by rememberInstance()
    // SH-168: the device's connection, for the offline banner.
    val connectivity: com.evoapps.evoshift.connectivity.ConnectivityWatcher by rememberInstance()
    val connectionNotice by remember(connectivity) { connectivity.isOnline.connectionNotices() }.collectAsState(com.evoapps.evoshift.connectivity.ConnectionNotice.NONE)

    // Created before anything can return early, so its saved back stack is restored after the
    // process was gone (the first frames only wait for the sign-in state).
    val navController = rememberNavController()

    if (rootState is RootState.Loading) {
        Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
            CircularProgressIndicator()
        }
        return
    }
    // SH-107: a paired clock-in tablet shows only the kiosk, none of the app's screens.
    (rootState as? RootState.Kiosk)?.let { kiosk ->
        com.evoapps.evoshift.ui.kiosk.KioskHost(kiosk.session)
        return
    }
    val gate = rootState.gate()

    // Decided once, at launch: changing NavHost's start destination later swaps the whole graph
    // under the back stack (sign-out left the user on a dead screen). Later changes of the auth
    // state navigate explicitly (below). An invitation that replaces the first run starts there.
    val startDestination = remember {
        val start = startRoute(gate)
        if (window != null) return@remember start
        val link = DeepLinks.pending.value
        if (link != null && linkPlacement(gate, link, start::class) == LinkPlacement.ROOT) DeepLinks.consume() ?: start else start
    }

    // --- What the person may use at the current workplace decides the tabs and the More hub.
    val workplaceId = dashboardState.currentWorkplaceId
    val user = notificationsState.user
    val capabilities = remember(user, workplaceId) { currentCapabilities(user, workplaceId) }
    // Only with the person and their workplace known; before, nothing is taken away.
    val capabilitiesKnown = user != null && workplaceId != null
    val tabs = remember(capabilities) { tabsFor(capabilities) }

    val backStack by navController.currentBackStack.collectAsState()
    val stackRoutes = remember(backStack) { backStack.routeClasses() }
    val currentRoute = stackRoutes.lastOrNull()
    val selected = selectedTab(stackRoutes, tabs)
    // SH-180: pay, contact details and money stay out of the system's screenshots (recents, the
    // app switcher, screen recordings) while such a screen is on top.
    SecureScreenEffect(SecureScreens.isSecure(currentRoute))

    fun openRoute(route: Route) {
        if (!capabilitiesKnown || canOpen(route::class, capabilities)) navController.open(route, tabs)
    }

    // Signing out anywhere (profile, expired session, account switch) returns to login with an
    // empty back stack, so no screen of the previous user stays reachable.
    val sessionManager: WorkplaceSessionManager by rememberInstance()
    // SH-89: the workplace and month of the shared top bar; month screens follow it.
    val monthSelection: WorkplaceMonthSelection by rememberInstance()
    val selectedMonth by monthSelection.month.collectAsState()
    val resetBillingIdentity: ResetBillingIdentityUseCase by rememberInstance()
    LaunchedEffect(rootState) {
        if (rootState !is RootState.NotLoggedIn) return@LaunchedEffect
        sessionManager.setWorkplaceId(null)
        monthSelection.reset()
        // The store SDK forgets the previous account too (SH-38).
        resetBillingIdentity()
        if (navController.currentDestination?.hasRoute(Route.Login::class) == false) {
            navController.openAsRoot(Route.Login)
        }
    }

    // A link opens once the person can see it: also when the app was already open (Android's
    // new intent), and after signing in (the login screen hands it over itself).
    val pendingLink by DeepLinks.pending.collectAsState()
    LaunchedEffect(pendingLink, gate, currentRoute) {
        if (window != null) return@LaunchedEffect
        val link = pendingLink ?: return@LaunchedEffect
        when (linkPlacement(gate, link, currentRoute)) {
            LinkPlacement.WAIT -> Unit
            LinkPlacement.ROOT -> DeepLinks.consume()?.let { navController.openAsRoot(it) }
            LinkPlacement.ON_TOP -> DeepLinks.consume()?.let { openRoute(it) }
        }
    }
    // SH-161 F3: a roster's window opens it on top of the window's home, once (back leads home).
    var windowRouteOpened by rememberSaveable { mutableStateOf(false) }
    LaunchedEffect(window, gate, currentRoute, capabilitiesKnown) {
        val route = window?.startRoute?.takeIf { window.rosterId != null } ?: return@LaunchedEffect
        if (windowRouteOpened || gate != SessionGate.READY || currentRoute != Route.Dashboard::class || !capabilitiesKnown) return@LaunchedEffect
        windowRouteOpened = true
        openRoute(route)
    }

    // A new workplace: screens of the previous one (a month, its settings, its daily records) and
    // the tabs' saved stacks would show it under the new workplace's name, so they go.
    val sessionWorkplaceId by sessionManager.currentWorkplaceId.collectAsState()
    var shownWorkplaceId by remember { mutableStateOf(sessionWorkplaceId) }
    LaunchedEffect(sessionWorkplaceId) {
        val previous = shownWorkplaceId
        shownWorkplaceId = sessionWorkplaceId
        if (previous == null || sessionWorkplaceId == null || previous == sessionWorkplaceId) return@LaunchedEffect
        navController.leaveWorkplaceScreens()
    }

    // A role that may no longer see a screen (another role at the new workplace, an ended
    // engagement): home, and the tabs forget what they kept.
    LaunchedEffect(capabilities, capabilitiesKnown, stackRoutes) {
        if (capabilitiesKnown && mustLeaveForHome(stackRoutes, capabilities)) {
            navController.forgetTabStacks()
            navController.goHome()
        }
    }

    // SH-161 F4: a sales file opened with the app (Open with, Share; Android) asks where it goes
    // once the person is signed in; the main window only. Sales import then opens once the chosen
    // workplace is the shown one (switching it closes the previous workplace's screens first).
    if (window == null) {
        val incomingFile by IncomingSalesFiles.waiting.collectAsState()
        val file = incomingFile
        if (file != null && gate == SessionGate.READY && capabilitiesKnown && currentRoute !in fullScreenRoutes) {
            IncomingSalesFileDialog(
                file = file,
                workplaces = remember(user, dashboardState.availableWorkplaceIds) { salesImportWorkplaces(user, dashboardState.availableWorkplaceIds) },
                currentWorkplaceId = workplaceId,
                onImport = { chosen, month ->
                    IncomingSalesFiles.handOver(chosen, month)
                    monthSelection.openAt(chosen, month)
                },
                onDismiss = IncomingSalesFiles::dismiss
            )
        }
        val salesHandoff by IncomingSalesFiles.handoff.collectAsState()
        LaunchedEffect(salesHandoff, shownWorkplaceId, workplaceId, capabilities) {
            val handoff = salesHandoff ?: return@LaunchedEffect
            if (handoff.workplaceId != shownWorkplaceId || handoff.workplaceId != workplaceId) return@LaunchedEffect
            if (canOpen(Route.SalesImport::class, capabilities)) {
                if (currentRoute != Route.SalesImport::class) openRoute(Route.SalesImport)
            } else {
                IncomingSalesFiles.clearHandoff()
            }
        }
    }

    // --- Crash reports and usage statistics (SH-86): the uid only (never a name or e-mail), the
    // role and number of workplaces for crash reports, and screen views by route name. All of it
    // goes through the consent gate: nothing leaves the device until the person allowed it.
    val telemetry: Telemetry by rememberInstance()
    val signedInUid = (rootState as? RootState.LoggedIn)?.let { user?.uid }
    LaunchedEffect(signedInUid, rootState) {
        if (rootState is RootState.NotLoggedIn) telemetry.setUserId(null) else if (signedInUid != null) telemetry.setUserId(signedInUid)
    }
    val role = workplaceId?.let { user?.engagements?.get(it)?.permission?.name }
    val workplaceCount = dashboardState.availableWorkplaceIds.size
    LaunchedEffect(role, workplaceCount) { telemetry.setCrashContext(role, workplaceCount) }
    LaunchedEffect(currentRoute) {
        currentRoute?.simpleName?.let { telemetry.logEvent(AnalyticsEvent.ScreenView(it)) }
    }
    // Asked once per device, only in builds that can collect at all (not debug, not localhost).
    val privacyChoices: PrivacyChoicesViewModel = diViewModel()
    var askPrivacy by remember { mutableStateOf(privacyChoices.shouldAsk) }
    if (askPrivacy) {
        PrivacyConsentSheet(viewModel = privacyChoices, onDone = { askPrivacy = false })
    }
    // SH-146: "What's new" once after an update, for the person's role at the current workplace.
    val whatsNewDue by whatsNewViewModel.due.collectAsState()
    val forManager = whatsNewForManager(user, workplaceId)
    if (whatsNewDue && !askPrivacy && gate == SessionGate.READY && user != null) {
        com.evoapps.evoshift.ui.whatsnew.WhatsNewSheet(forManager = forManager, onDismiss = whatsNewViewModel::dismiss)
    }

    // --- The app-wide workplace chooser: one sheet, opened from the top bar's workplace and More
    // (SH-89: the month is the top bar's). Picking closes it.
    var showSwitcher by remember { mutableStateOf(false) }
    val contextSwitcher = remember { ContextSwitcher { showSwitcher = true } }
    fun openRoster(roster: Roster) {
        val route: Route = if (roster.status == RosterStatus.SKELETON) Route.RosterSkeleton(roster.id) else Route.RosterDetail(roster.id)
        val current = navController.currentDestination
        navController.navigate(route) {
            // Months replace each other instead of piling up behind the back button.
            if (current != null && (current.hasRoute(Route.RosterDetail::class) || current.hasRoute(Route.RosterSkeleton::class))) {
                popUpTo(current.id) { inclusive = true }
            }
            launchSingleTop = true
        }
    }
    /** A person in the dashboards' "Today at work": that day of their month (SH-72). */
    fun openAtWork(entry: AtWorkEntry) {
        val roster = dashboardState.activeRosters.firstOrNull { it.id == entry.rosterId }
        if (roster?.status == RosterStatus.SKELETON) openRoster(roster) else openRoute(Route.RosterDetail(entry.rosterId, entry.date))
    }

    val openInNewWindow = com.evoapps.evoshift.shell.rememberOpenInNewWindow()
    if (showSwitcher) {
        val canManage = Capability.EDIT_WORKPLACE_SETTINGS in capabilities
        ContextSwitchBottomSheet(
            onDismiss = { showSwitcher = false },
            workplaces = dashboardState.availableWorkplaceIds,
            currentWorkplaceId = dashboardState.currentWorkplaceId.orEmpty(),
            onWorkplaceSelected = { id ->
                showSwitcher = false
                dashboardViewModel.onEvent(DashboardEvent.SelectWorkplace(id))
            },
            onAddWorkplace = {
                showSwitcher = false
                openRoute(Route.CreateWorkplace)
            },
            onEditWorkplace = if (canManage) { id ->
                showSwitcher = false
                openRoute(Route.WorkplaceSettings(id))
            } else null,
            onOpenInNewWindow = openInNewWindow?.let { open ->
                { id: String ->
                    showSwitcher = false
                    open(WindowTarget.forWorkplace(id))
                }
            }
        )
    }

    val openProfile = { navController.openOnce(Route.Profile) }
    // SH-164: requests waiting for this manager's decision count on the Requests tab, or on More
    // where Requests lives there (owners and financial managers have Money in its place).
    val pendingRequests by pendingRequestsViewModel.count.collectAsStateWithLifecycle()
    val badges = tabBadges(tabs, unreadNotifications = notificationsState.unreadCount, pendingRequests = pendingRequests)
    val workplaceName = workplaceId?.let { dashboardState.availableWorkplaceIds[it] }
    val navyTopBars = remember { NavyTopBars() }
    val markedMonths = remember(dashboardState.activeRosters) { dashboardState.activeRosters.map { it.yearMonth }.toSet() }
    val topBarSelection = TopBarSelection(
        workplaces = dashboardState.availableWorkplaceIds,
        workplaceId = workplaceId,
        month = selectedMonth,
        currentMonth = monthSelection.currentMonth,
        markedMonths = markedMonths,
        onSwitchWorkplace = contextSwitcher.open,
        onMonth = monthSelection::selectMonth
    )
    val knownRosters = KnownRosters(dashboardState.currentWorkplaceId, dashboardState.activeRosters, dashboardState.isLoadingRosters)
    // SH-170: what the home screens' "Do zrobienia" rows open.
    fun openRosterById(rosterId: String) {
        dashboardState.activeRosters.firstOrNull { it.id == rosterId }?.let { openRoster(it) } ?: openRoute(Route.RosterDetail(rosterId))
    }
    val todoActions = com.evoapps.evoshift.ui.user.TodoActions(
        openRequests = { openRoute(Route.Requests) },
        enterTakings = { wpId, date -> openRoute(Route.DailyRecords(wpId, com.evoapps.evoshift.domain.model.RosterIds.of(wpId, date.year, date.month.number), entryDate = date.toString())) },
        // SH-257: "Potwierdź godziny z wczoraj".
        openWorkHours = { wpId, date -> openRoute(Route.WorkHours(wpId, date.toString())) },
        openPay = { wpId, userId -> openRoute(Route.EmployeeForm(wpId, userId)) },
        openRoster = { openRosterById(it) },
        openCapacity = { openRoute(Route.RosterCapacity(it)) },
        openMyShifts = { openRoute(Route.Schedule()) },
        openAvailability = { openRoute(Route.AvailabilityForm(it)) },
        openPolicies = { openRoute(Route.Policies(it)) },
        openProfile = openProfile,
        openMarketplace = { openRoute(Route.Schedule(showMarketplace = true)) }
    )
    @Composable
    fun DashboardTodo(showClockReview: (() -> Unit)?) {
        val todoModel = diViewModel<com.evoapps.evoshift.viewmodels.TodoViewModel>()
        val todo by todoModel.uiState.collectAsStateWithLifecycle()
        // Back on the home screen (after typing takings, say): read it again.
        LaunchedEffect(Unit) { todoModel.refresh() }
        com.evoapps.evoshift.ui.user.TodoCard(
            state = todo,
            actions = com.evoapps.evoshift.ui.user.TodoActions(
                openRequests = todoActions.openRequests,
                showClockReview = showClockReview,
                enterTakings = todoActions.enterTakings,
                openWorkHours = todoActions.openWorkHours,
                openPay = todoActions.openPay,
                openRoster = todoActions.openRoster,
                openCapacity = todoActions.openCapacity,
                remind = { item, title, message -> todoModel.remind(item, title, message) },
                openMyShifts = todoActions.openMyShifts,
                openAvailability = todoActions.openAvailability,
                openPolicies = todoActions.openPolicies,
                openProfile = todoActions.openProfile,
                openMarketplace = todoActions.openMarketplace
            ),
            onMessageShown = todoModel::messageShown
        )
    }
    /** SH-89: a month screen replaced by another month's (months never pile up behind Back). */
    fun replaceCurrent(route: Route) {
        val current = navController.currentDestination ?: return
        navController.navigate(route) {
            popUpTo(current.id) { inclusive = true }
            launchSingleTop = true
        }
    }
    /** "Create roster" for the top bar's month (SH-89), for those who build rosters. */
    // SH-219: the start path's calendar link (the owner's own subscription, SH-202).
    var showStartPathCalendar by remember { mutableStateOf(false) }
    val createRosterForMonth: ((YearMonth) -> Unit)? = workplaceId?.takeIf { Capability.EDIT_ROSTER in capabilities }?.let { wp ->
        { month -> openRoute(Route.CreateRoster(wp, workplaceName.orEmpty(), month.year, month.month.number)) }
    }

    BindBrowserBack(navController)

    // --- SH-103: screen changes (ui/theme/Motion.kt). A screen opened on top slides in (shared
    // axis X) and back out (also the browser's Back and Android's predictive back, which drives
    // the pop transition); another section fades through. The sections of the stack decide.
    // SH-198: on iOS screens slide over each other instead, so the edge swipe uncovers the
    // previous screen whole (shared axis faded both out mid-swipe: black).
    val reducedMotion = com.evoapps.evoshift.ui.theme.LocalReducedMotion.current
    val stackMotion = com.evoapps.evoshift.ui.theme.LocalStackMotion.current
    val entryTabs = remember { NavEntryTabs() }
    entryTabs.record(backStack, tabs)
    fun AnimatedContentTransitionScope<NavBackStackEntry>.motion(isPop: Boolean): NavMotion {
        entryTabs.record(navController.currentBackStack.value, tabs)
        return navMotion(entryTabs, isPop, reducedMotion, stackMotion)
    }

    // --- SH-98: keyboard shortcuts (Googlebook and other laptops, the browser): the shell's own
    // here, the screens' through ShortcutHandler. Only in the signed-in app, never on sign-in.
    val appShortcuts = remember { AppShortcuts() }
    DisposableEffect(appShortcuts) {
        KeyboardShortcuts.active = appShortcuts
        onDispose {
            if (KeyboardShortcuts.active === appShortcuts) {
                KeyboardShortcuts.active = null
                KeyboardShortcuts.help = emptyList()
            }
        }
    }
    val shortcutsOn = gate == SessionGate.READY && currentRoute != null && currentRoute !in fullScreenRoutes
    val canCreateRoster = workplaceId != null && dashboardState.capabilities.shows(Gate.ROSTER_EDITING)
    val settingsRoute: Route = workplaceId?.takeIf { Capability.EDIT_WORKPLACE_SETTINGS in capabilities }
        ?.let { Route.WorkplaceSettings(it) } ?: Route.Profile
    SideEffect {
        appShortcuts.shell = shell@{ shortcut ->
            if (!shortcutsOn) return@shell false
            val tabIndex = shortcut.tabIndex
            when {
                tabIndex != null -> tabs.getOrNull(tabIndex)?.let { navController.selectTab(it, tabs); true } ?: false
                shortcut == AppShortcut.NEW_ROSTER && canCreateRoster && workplaceId != null -> {
                    // The month the top bar shows (SH-89), as its "Create roster" does.
                    openRoute(Route.CreateRoster(workplaceId, workplaceName.orEmpty(), selectedMonth.year, selectedMonth.month.number))
                    true
                }
                shortcut == AppShortcut.SETTINGS -> {
                    if (settingsRoute is Route.Profile) navController.openOnce(settingsRoute) else openRoute(settingsRoute)
                    true
                }
                else -> false
            }
        }
    }
    // What works on this screen: the system's shortcut helper (Meta + /) and the desktop menu bar
    // (SH-97) list the same.
    val availableShortcuts = buildSet {
        tabs.indices.mapNotNullTo(this) { AppShortcut.forTab(it) }
        add(AppShortcut.SETTINGS)
        if (canCreateRoster) add(AppShortcut.NEW_ROSTER)
        addAll(appShortcuts.screenShortcuts)
    }
    val shortcutHelp = shortcutHelp(on = shortcutsOn, tabs = tabs, available = availableShortcuts)
    SideEffect { KeyboardShortcuts.help = shortcutHelp }

    // SH-97: the desktop app's menu bar (no shell on phones, tablets and the web). Its shortcut
    // items go through the same registry as the keys; the others have no key.
    LocalAppShell.current?.let { shell ->
        val ready = gate == SessionGate.READY
        SideEffect {
            shell.publish(
                ShellState(
                    signedIn = ready,
                    tabs = if (ready) tabs else emptyList(),
                    selectedTab = if (ready) selected else null,
                    shortcuts = if (shortcutsOn) availableShortcuts else emptySet(),
                    canGoBack = stackRoutes.size > 1,
                    workplaces = if (ready) dashboardState.availableWorkplaceIds else emptyMap(),
                    workplaceId = workplaceId,
                    month = selectedMonth,
                    unreadNotifications = notificationsState.unreadCount
                )
            )
        }
        val handle by rememberUpdatedState { command: AppCommand ->
            if (ready || command == AppCommand.Back) when (command) {
                is AppCommand.Shortcut -> appShortcuts.handle(command.shortcut)
                AppCommand.ThisMonth -> monthSelection.selectMonth(monthSelection.currentMonth)
                AppCommand.SwitchWorkplace -> contextSwitcher.open()
                is AppCommand.SelectWorkplace -> dashboardViewModel.onEvent(DashboardEvent.SelectWorkplace(command.workplaceId))
                AppCommand.OpenNotifications -> navController.openOnce(Route.Notifications)
                // SH-141: a click on a Mac notification opens what the list would, through the links
                // (which wait while the person cannot see it), and reads it.
                is AppCommand.OpenNotification -> {
                    val notification = notificationsState.items.firstOrNull { it.id == command.id }
                    if (notification == null) navController.openOnce(Route.Notifications)
                    else {
                        notificationsViewModel.markRead(notification)
                        DeepLinks.open(notification.destinationFor(notificationsState.user) ?: Route.Notifications)
                    }
                }
                AppCommand.OpenProfile -> openProfile()
                // SH-105: an open detail pane closes before the screen is left.
                AppCommand.Back -> if (!DetailPanes.closeNewest() && stackRoutes.size > 1) navController.popBackStack()
            }
        }
        LaunchedEffect(shell) { shell.commands.collect { handle(it) } }
        // SH-141: new notifications to the system's notification centre while the app runs.
        ShellNotifications(
            shell = shell,
            user = notificationsState.user.takeIf { ready },
            items = notificationsState.items,
            loaded = ready && !notificationsState.isLoading
        )
    }

    // SH-102: the device's posture (foldables: iPhone Duo, Pixel Fold); tests and the store
    // screenshots fix it. Screens arrange content and controls around a hinge with
    // PostureAwareScaffold.
    val posture = LocalDevicePostureOverride.current ?: rememberPlatformDevicePosture()
    // Responsive shell: bottom bar on phones, navigation rail on tablets and desktop browsers.
    // Screens read LocalWindowWidthClass for their own layout decisions.
    CompositionLocalProvider(LocalDevicePosture provides posture) {
    ProvideWindowWidthClass { widthClass ->
        // Like a laptop (a horizontal hinge), the tabs go to the bottom half with the controls.
        val chrome = navChromeFor(currentRoute, isWide = !widthClass.isCompact, tabletop = posture.isTabletop)
        // Edge to edge: icons that read on the screen under the status bar (SH-83).
        // A navy shared top bar (SH-89) wants light icons on any route.
        val darkStatusIcons = darkStatusIconsFor(currentRoute) && navyTopBars.count == 0
        SystemBarIcons(darkStatusIcons = darkStatusIcons, darkNavigationIcons = darkNavigationIconsFor(currentRoute, chrome))
        // SH-98: shortcuts while something in the app has focus (text boxes keep their own keys:
        // a key they use never gets here); MainActivity passes them on when nothing has.
        Row(modifier = Modifier.fillMaxSize().onKeyEvent { appShortcuts.handle(it) }) {
            if (chrome == NavChrome.RAIL) {
                AppNavigationRail(
                    tabs = tabs,
                    selected = selected,
                    badges = badges,
                    onSelect = { navController.selectTab(it, tabs) },
                    // The status bar spans the rail too: one colour under it, the screen's.
                    statusBarColor = if (darkStatusIcons) Cream else DeepNavy
                )
            }
            // The bar takes the system navigation bar's inset; the screens' own Scaffolds must not
            // add it again.
            val contentModifier = if (chrome == NavChrome.BAR) {
                Modifier.consumeWindowInsets(NavigationBarDefaults.windowInsets)
            } else Modifier
            // Every screen's bell opens the notifications screen.
            CompositionLocalProvider(
                LocalOpenNotifications provides { navController.openOnce(Route.Notifications) },
                // SH-147: "Set pay" in the missing-pay warnings opens the person's pay terms.
                com.evoapps.evoshift.ui.finance.LocalOpenPayTerms provides { workplaceId, userId -> openRoute(Route.EmployeeForm(workplaceId, userId)) },
                LocalContextSwitcher provides contextSwitcher,
                LocalTopBarSelection provides topBarSelection,
                LocalNavyTopBars provides navyTopBars,
                LocalAppShortcuts provides appShortcuts,
                LocalPendingSaves provides pendingSaves
            ) {
            // SH-160: the rail covers the start side's system area (the notch of an iPhone in
            // landscape); the screens beside it must not pad it again.
            val besideRail = if (chrome == NavChrome.RAIL) {
                Modifier.consumeWindowInsets(RailWindowInsets.only(WindowInsetsSides.Start))
            } else Modifier
            // SH-248: the screens' transitions stay beside the rail. Unclipped, a screen sliding
            // (iOS: the covered one shifts a third of the width to the start, the uncovered one
            // comes from there; shared axis X: 12%) or a shared top bar in flight was drawn over the
            // rail, so the rail seemed to move whenever Account or another section opened.
            Column(Modifier.weight(1f).then(besideRail).clipToBounds()) {
            // The screens' top bars share their place (Modifier.sharedTopBar): the bar stays
            // while the screens change under it.
            SharedTransitionLayout(Modifier.weight(1f).fillMaxWidth().then(contentModifier)) {
            CompositionLocalProvider(LocalSharedTransitionScope provides this) {
            // SH-148: saves that ended after their screen was left say so over any screen.
            Box(Modifier.fillMaxSize()) {
            NavHost(
                navController = navController,
                startDestination = startDestination,
                modifier = Modifier.fillMaxSize(),
                enterTransition = { enterFor(motion(isPop = false)) },
                exitTransition = { exitFor(motion(isPop = false)) },
                popEnterTransition = { enterFor(motion(isPop = true)) },
                popExitTransition = { exitFor(motion(isPop = true)) }
            ) {
                composable<Route.Login> {
                    val viewModel: AuthViewModel = diViewModel()
                    val waitingLink by DeepLinks.pending.collectAsState()
                    AuthScreen(
                        viewModel = viewModel,
                        // An invitation waits for the account (it can only be read signed in).
                        headerContent = if (waitingLink is Route.JoinTeam) {
                            { PendingInvitationHeader() }
                        } else null,
                        onNavigateToDashboard = { navController.signedIn() }
                    )
                }

                composable<Route.CreateWorkplace> {
                    val viewModel: WorkplaceCreationViewModel = diViewModel()
                    CreateWorkplaceScreen(
                        viewModel = viewModel,
                        onNavigateToDashboard = { navController.goHome() },
                        onSeePlans = { navController.navigate(Route.Paywall) { launchSingleTop = true } }
                    )
                }

                composable<Route.Team> {
                    val viewModel: TeamManagementViewModel = diViewModel()
                    TeamManagementScreen(
                        viewModel = viewModel,
                        onCreateNewWorkplaceClicked = { openRoute(Route.CreateWorkplace) },
                        onRosterSelected = { roster -> openRoster(roster) },
                        onNavigateToSettings = { id -> openRoute(Route.WorkplaceSettings(id)) },
                        onNavigateToProfile = openProfile,
                        onNavigateToEmployeeForm = { workplaceId, employeeId ->
                            openRoute(Route.EmployeeForm(workplaceId, employeeId))
                        },
                        onNavigateToWorkplaceSettings = { wpId -> openRoute(Route.WorkplaceSettings(wpId)) },
                        onOpenShiftDay = { rosterId, date -> openRoute(Route.RosterDetail(rosterId, date)) },
                        onOpenLeaveBalances = { openRoute(Route.LeaveBalances) },
                        onOpenHiring = { openRoute(Route.Hiring) },
                        onOpenImport = { workplaceId -> openRoute(Route.StaffImport(workplaceId)) },
                        // SH-268: a group manager's engagement is changed in the owner's groups.
                        onOpenWorkplaceGroups = { openRoute(Route.WorkplaceGroups) },
                        // SH-269: selecting people and changing them at once.
                        bulkEdit = diViewModel<com.evoapps.evoshift.viewmodels.BulkEmployeeEditViewModel>(),
                        // SH-105: wide windows show the form beside the list; its view model
                        // lives while that person is shown.
                        employeeDetail = { workplaceId, employeeId, onClose ->
                            val args = Route.EmployeeForm(workplaceId, employeeId)
                            PaneViewModelStore(key = args) {
                                EmployeeFormScreen(
                                    viewModel = diViewModel<Route.EmployeeForm, EmployeeFormViewModel>(args),
                                    onNavigateBack = onClose,
                                    onSeePlans = { navController.navigate(Route.Paywall) { launchSingleTop = true } },
                                    // SH-212: the timeline needs the whole width: its own screen.
                                    onOpenTimeline = { id -> openRoute(Route.EmployeeTimeline(workplaceId, id)) }
                                )
                            }
                        }
                    )
                }

                composable<Route.RosterManagement> {
                    val viewModel: DashboardViewModel by rememberInstance()
                    RosterManagementScreen(
                        viewModel = viewModel,
                        onCreateNewRoster = { wpId, wpName -> openRoute(Route.CreateRoster(wpId, wpName)) },
                        onRosterSelected = { roster -> openRoster(roster) },
                        onSkeletonEditorSelected = { wpId -> openRoute(Route.SkeletonEditor(wpId)) },
                        onNavigateToProfile = openProfile,
                        onCreateNewWorkplaceClicked = { openRoute(Route.CreateWorkplace) },
                        onNavigateToWorkplaceSettings = { wpId -> openRoute(Route.WorkplaceSettings(wpId)) },
                        onOpenCapacity = { roster -> openRoute(Route.RosterCapacity(roster.id)) },
                        onCreateRosterForMonth = { wpId, wpName, year, month -> openRoute(Route.CreateRoster(wpId, wpName, year, month)) },
                        // SH-170: each month's four steps with their numbers.
                        tracker = diViewModel<com.evoapps.evoshift.viewmodels.RosterTrackerViewModel>()
                    )
                }

                composable<Route.Availability> {
                    val viewModel: AvailabilityViewModel = diViewModel()
                    AvailabilityScreen(
                        viewModel = viewModel,
                        onNavigateToFill = { rosterId -> openRoute(Route.AvailabilityForm(rosterId)) },
                        onNavigateToTemplate = { templateId, openNew ->
                            openRoute(Route.WeeklyTemplates(editTemplateId = templateId, openNew = openNew))
                        },
                        onViewAllTemplates = { openRoute(Route.WeeklyTemplates()) },
                        onNavigateToProfile = openProfile,
                        // A tab's root has no back arrow (back returns home); reached from More, it has (SH-110).
                        onNavigateBack = if (AppTab.AVAILABILITY in tabs) null else { { navController.popBackStack() } }
                    )
                }

                composable<Route.Schedule> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.Schedule>()
                    val viewModel: ScheduleViewModel = diViewModel()
                    ScheduleScreen(
                        viewModel = viewModel,
                        initialShowMarketplace = args.showMarketplace,
                        onNavigateToProfile = openProfile,
                        onNavigateBack = if (AppTab.MY_SHIFTS in tabs) null else { { navController.popBackStack() } }
                    )
                }

                composable<Route.AvailabilityForm> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.AvailabilityForm>()
                    // SH-89: the month follows the top bar's; the months to choose are those the
                    // manager asked availability for (marked in the picker).
                    val requests by diViewModel<AvailabilityViewModel>().uiState.collectAsState()
                    val requested = remember(requests.openRosters, requests.pastRosters) { requests.openRosters + requests.pastRosters }
                    CompositionLocalProvider(
                        LocalTopBarSelection provides topBarSelection.withMarkedMonths(requested.map { it.yearMonth }.toSet())
                    ) {
                        RosterMonthHost(
                            entryRosterId = args.rosterId,
                            selection = monthSelection,
                            known = KnownRosters(requests.currentWorkplaceId, requested, requests.isLoading),
                            onReplace = { replaceCurrent(Route.AvailabilityForm(it.id)) },
                            missing = { month ->
                                NoRosterForMonth(
                                    month = month,
                                    title = stringResource(Res.string.availability_my_availability),
                                    onBack = { navController.popBackStack() },
                                    message = stringResource(Res.string.top_bar_no_availability_request, "${monthName(month.month.number)} ${month.year}"),
                                    showWorkplace = false
                                )
                            }
                        ) {
                            val viewModel: AvailabilityFormViewModel = diViewModel(args.rosterId)
                            AvailabilityFormScreen(
                                viewModel = viewModel,
                                onNavigateBack = { navController.popBackStack() }
                            )
                        }
                    }
                }

                composable<Route.WeeklyTemplates> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.WeeklyTemplates>()
                    val viewModel: WeeklyTemplatesViewModel = diViewModel(args)
                    WeeklyTemplatesScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.RosterDetail> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.RosterDetail>()
                    // SH-89: the month follows the top bar's (another month replaces this entry).
                    RosterMonthHost(
                        entryRosterId = args.rosterId,
                        selection = monthSelection,
                        known = knownRosters,
                        onReplace = { openRoster(it) },
                        missing = { month ->
                            NoRosterForMonth(
                                month = month,
                                onBack = { navController.popBackStack() },
                                onCreate = createRosterForMonth?.let { create -> { create(month) } }
                            )
                        }
                    ) {
                        val viewModel: RosterDetailViewModel = diViewModel(args.rosterId)
                        RosterBuilderScreen(
                            viewModel = viewModel,
                            onNavigateBack = { navController.popBackStack() },
                            onShiftClick = {},
                            initialDay = args.day?.let { runCatching { LocalDate.parse(it) }.getOrNull() },
                            onImport = { rosterId -> openRoute(Route.RosterImport(rosterId)) },
                            initialAction = args.action
                        )
                    }
                }

                composable<Route.Dashboard> {
                    val viewModel: DashboardViewModel by rememberInstance()
                    DashboardScreen(
                        viewModel = viewModel,
                        onCreateNewWorkplaceClicked = { openRoute(Route.CreateWorkplace) },
                        // No workplace yet (e.g. signed in on a new account): the onboarding.
                        // Only from home itself: a leaving dashboard (an invitation opened
                        // instead) must not take the person elsewhere.
                        onNeedsOnboarding = {
                            if (navController.currentDestination?.hasRoute(Route.Dashboard::class) == true) {
                                navController.openAsRoot(Route.Onboarding)
                            }
                        },
                        onNavigateToRoster = { rosterId ->
                            dashboardState.activeRosters.firstOrNull { it.id == rosterId }?.let { openRoster(it) }
                                ?: openRoute(Route.RosterDetail(rosterId))
                        },
                        onNavigateToWorkplaceSettings = { wpId -> openRoute(Route.WorkplaceSettings(wpId)) },
                        employeeDashboardContent = { onSwitchWorkplaceClicked ->
                            EmployeeDashboardScreen(
                                viewModel = diViewModel<EmployeeDashboardViewModel>(),
                                onNavigateToProfile = openProfile,
                                onNavigateToMyShifts = { openRoute(Route.Schedule()) },
                                onNavigateToMarketplace = { openRoute(Route.Schedule(showMarketplace = true)) },
                                onSwitchWorkplaceClicked = onSwitchWorkplaceClicked,
                                // SH-170: availability to send, the next shift, swaps, policies, the marketplace.
                                todo = { DashboardTodo(showClockReview = null) },
                                // SH-121: today's checklists of the person's shifts; SH-126: courses to do.
                                myChecklists = {
                                    MyChecklistsCard(diViewModel<MyChecklistsViewModel>(), onOpen = { openRoute(Route.ShiftChecklist(it)) })
                                    com.evoapps.evoshift.ui.courses.TrainingCard(
                                        diViewModel<com.evoapps.evoshift.viewmodels.MyTrainingViewModel>(),
                                        onOpen = { openRoute(Route.Courses(it)) }
                                    )
                                    // SH-239: once after joining a team, "Recommend EVoShift".
                                    com.evoapps.evoshift.ui.growth.RecommendPromptSection(
                                        diViewModel<com.evoapps.evoshift.viewmodels.RecommendPromptViewModel>(),
                                        onRecommend = { openRoute(Route.Recommend) }
                                    )
                                }
                            )
                        },
                        managerDashboardContent = { onSwitchWorkplaceClicked ->
                            val todayChecklists = diViewModel<TodayChecklistsViewModel>()
                            ManagerDashboardScreen(
                                viewModel = diViewModel<ManagerDashboardViewModel>(),
                                onNavigateToProfile = openProfile,
                                onNavigateToRoster = { openRoute(Route.RosterManagement) },
                                onNavigateToRequests = { openRoute(Route.Requests) },
                                // SH-170: requests, clock-ins, unfilled shifts, availability, publishing.
                                todo = { showClockReview -> DashboardTodo(showClockReview) },
                                onNavigateToTeam = { openRoute(Route.Team) },
                                onSwitchWorkplaceClicked = onSwitchWorkplaceClicked,
                                onOpenAtWork = { openAtWork(it) },
                                // SH-121: checklists in "Today at work" and the manager's own.
                                atWorkExtra = { entry ->
                                    AtWorkChecklists(todayChecklists, entry.shiftId, onOpen = { openRoute(Route.Checklists(date = entry.date)) })
                                },
                                // SH-134: flagged and unplanned clock-ins to review.
                                clockReview = { ClockReviewCard(diViewModel<ClockReviewViewModel>()) },
                                myChecklists = {
                                    MyChecklistsCard(diViewModel<MyChecklistsViewModel>(), onOpen = { openRoute(Route.ShiftChecklist(it)) })
                                    com.evoapps.evoshift.ui.courses.TrainingCard(
                                        diViewModel<com.evoapps.evoshift.viewmodels.MyTrainingViewModel>(),
                                        onOpen = { openRoute(Route.Courses(it)) }
                                    )
                                    // SH-239: once after joining a team, "Recommend EVoShift".
                                    com.evoapps.evoshift.ui.growth.RecommendPromptSection(
                                        diViewModel<com.evoapps.evoshift.viewmodels.RecommendPromptViewModel>(),
                                        onRecommend = { openRoute(Route.Recommend) }
                                    )
                                }
                            )
                        },
                        ownerDashboardContent = { onSwitchWorkplaceClicked ->
                            val todayChecklists = diViewModel<TodayChecklistsViewModel>()
                            OwnerDashboardScreen(
                                viewModel = diViewModel<OwnerDashboardViewModel>(),
                                onNavigateToProfile = openProfile,
                                onNavigateToFinancials = {
                                    // The month the dashboard's figures are about: the top bar's
                                    // (SH-89), else the current one, not the newest draft.
                                    val today = AppClock.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
                                    val rosterId = (dashboardState.activeRosters.of(selectedMonth)
                                        ?: dashboardState.activeRosters.currentOrNearest(today.year, today.month.number))?.id
                                    if (workplaceId != null && rosterId != null) {
                                        openRoute(Route.DailyRecords(workplaceId, rosterId))
                                    } else {
                                        openRoute(Route.Financials)
                                    }
                                },
                                onNavigateToTeam = { openRoute(Route.Team) },
                                // SH-170: "Do zrobienia" (SH-164's requests among them) and the first steps.
                                todo = { showClockReview -> DashboardTodo(showClockReview) },
                                // SH-219: the start path, first roster in ten minutes (it took over SH-170's first steps).
                                firstSteps = {
                                    com.evoapps.evoshift.ui.start.StartPathSection(
                                        viewModel = diViewModel<com.evoapps.evoshift.viewmodels.StartPathViewModel>(),
                                        actions = { wpId ->
                                            com.evoapps.evoshift.ui.start.StartPathActions(
                                                openBasics = { openRoute(Route.WorkplaceSettings(wpId)) },
                                                openShiftTemplates = { openRoute(Route.SkeletonEditor(wpId, openShiftTemplates = true)) },
                                                openWeek = { openRoute(Route.SkeletonEditor(wpId)) },
                                                invite = { openRoute(Route.Team) },
                                                addWithoutApp = { openRoute(Route.EmployeeForm(wpId)) },
                                                // SH-214: the team step's "Import from a spreadsheet".
                                                importTeam = { openRoute(Route.StaffImport(wpId)) },
                                                createRoster = { openRoute(Route.CreateRoster(wpId, dashboardState.availableWorkplaceIds[wpId]?.takeIf { it.isNotBlank() } ?: workplaceName.orEmpty())) },
                                                openDemand = { openRoute(Route.RosterSkeleton(it)) },
                                                autoAssign = { openRoute(Route.RosterDetail(it, action = com.evoapps.evoshift.ui.roster.RosterDetailAction.AUTO_ASSIGN)) },
                                                openRoster = { openRosterById(it) },
                                                emailPdf = { openRoute(Route.RosterDetail(it, action = com.evoapps.evoshift.ui.roster.RosterDetailAction.EMAIL)) },
                                                calendarLink = { showStartPathCalendar = true }
                                            )
                                        }
                                    )
                                    if (showStartPathCalendar) {
                                        com.evoapps.evoshift.ui.calendar.CalendarSubscriptionDialog(onDismiss = { showStartPathCalendar = false })
                                    }
                                    // SH-239: after the first published month, "Invite the team to the app" (the Team screen's invitations).
                                    com.evoapps.evoshift.ui.growth.TeamInviteSection(
                                        diViewModel<com.evoapps.evoshift.viewmodels.TeamInviteViewModel>(),
                                        onInvite = { openRoute(Route.Team) }
                                    )
                                },
                                onOpenAtWork = { openAtWork(it) },
                                // SH-121: checklists in "Today at work".
                                atWorkExtra = { entry ->
                                    AtWorkChecklists(todayChecklists, entry.shiftId, onOpen = { openRoute(Route.Checklists(date = entry.date)) })
                                },
                                // SH-134: flagged and unplanned clock-ins to review.
                                clockReview = { ClockReviewCard(diViewModel<ClockReviewViewModel>()) },
                                // SH-54: the staffing hints' month, to change its shifts.
                                onOpenRoster = { rosterId ->
                                    dashboardState.activeRosters.firstOrNull { it.id == rosterId }?.let { openRoster(it) }
                                        ?: openRoute(Route.RosterDetail(rosterId))
                                }
                            )
                        }
                    )
                }

                // Opened by links only (DeepLinks): the NavHost's own deep links would
                // open it before the person is signed in.
                composable<Route.JoinTeam> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.JoinTeam>()
                    val viewModel: JoinTeamViewModel = diViewModel()
                    JoinTeamScreen(
                        inviteCode = args.code,
                        viewModel = viewModel,
                        onNavigateToDashboard = {
                            if (rootState is RootState.NotLoggedIn) navController.openAsRoot(Route.Login)
                            else navController.goHome()
                        }
                    )
                }

                // SH-150: a voice assistant's request (DeepLinks: evoshift://app/voice/…).
                composable<Route.VoiceAction> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.VoiceAction>()
                    VoiceActionScreen(viewModel = diViewModel(args), onClose = { navController.goHome() })
                }

                composable<Route.CreateRoster> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.CreateRoster>()
                    val viewModel: CreateRosterViewModel = diViewModel(args)
                    CreateRosterScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() },
                        // SH-194: set up the missing days of the week; the month is filled on return.
                        onOpenWeeklySkeleton = { openRoute(Route.SkeletonEditor(args.workplaceId)) },
                        onRosterCreated = { rosterId ->
                            navController.navigate(Route.RosterSkeleton(rosterId)) {
                                popUpTo<Route.CreateRoster> { inclusive = true }
                                launchSingleTop = true
                            }
                        }
                    )
                }

                composable<Route.Profile> {
                    val viewModel: ProfileViewModel = diViewModel()
                    ProfileScreen(
                        viewModel = viewModel,
                        onNavigateToAuth = { navController.openAsRoot(Route.Login) },
                        onNavigateToRecurringCosts = { openRoute(Route.RecurringCosts) },
                        onNavigateToSharedCosts = { openRoute(Route.SharedCosts()) },
                        onNavigateToWorkplaceGroups = { openRoute(Route.WorkplaceGroups) },
                        onNavigateToRoles = { openRoute(Route.Roles) },
                        onNavigateToNotificationSettings = { openRoute(Route.NotificationSettings) },
                        // SH-122: my documents at the workplace I am in.
                        onNavigateToMyDocuments = workplaceId?.let { wpId -> { openRoute(Route.StaffDocuments(wpId)) } },
                        // SH-212: my timeline at the workplace I am in (read-only).
                        onNavigateToMyTimeline = workplaceId?.let { wpId -> { openRoute(Route.EmployeeTimeline(wpId)) } },
                        onNavigateBack = { navController.popBackStack() },
                        // SH-146: the notes of this version, for the role at the current workplace.
                        whatsNewForManager = forManager,
                        planEntry = {
                            OwnerPlanEntry(
                                viewModel = diViewModel<SubscriptionViewModel>(),
                                onClick = { openRoute(Route.Subscription) }
                            )
                        }
                    )
                }

                composable<Route.NotificationSettings> {
                    NotificationSettingsScreen(
                        viewModel = diViewModel<NotificationSettingsViewModel>(),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                // SH-121: the workplace's checklists (managers) and one shift's (its person).
                composable<Route.Checklists> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.Checklists>()
                    ChecklistsScreen(
                        viewModel = diViewModel<Route.Checklists, ChecklistsViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.ShiftChecklist> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.ShiftChecklist>()
                    ShiftChecklistScreen(
                        viewModel = diViewModel<String, ShiftChecklistViewModel>(args.shiftId),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.Subscription> {
                    SubscriptionScreen(
                        viewModel = diViewModel<SubscriptionViewModel>(),
                        onNavigateBack = { navController.popBackStack() },
                        onUpgrade = { navController.navigate(Route.Paywall) { launchSingleTop = true } }
                    )
                }

                composable<Route.Paywall> {
                    PaywallScreen(
                        viewModel = diViewModel<PlanChoiceViewModel>(),
                        onClose = { navController.popBackStack() },
                        onPurchased = { navController.popBackStack() }
                    )
                }

                composable<Route.Onboarding> {
                    OnboardingScreen(
                        viewModel = diViewModel<OnboardingViewModel>(),
                        onFinished = { navController.openAsRoot(Route.Dashboard) },
                        onSeePlans = { navController.navigate(Route.Paywall) { launchSingleTop = true } }
                    )
                }

                composable<Route.Tips> {
                    TipsScreen(
                        viewModel = diViewModel<TipsViewModel>(),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.LeaveBalances> {
                    LeaveBalancesScreen(
                        viewModel = diViewModel<LeaveBalancesViewModel>(),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.SalesImport> {
                    SalesImportScreen(
                        viewModel = diViewModel<SalesImportViewModel>(),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.RecurringCosts> {
                    val viewModel: RecurringCostRulesViewModel = diViewModel()
                    RecurringCostRulesScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() },
                        onConvertToShared = { ruleId -> openRoute(Route.SharedCosts(ruleId)) }
                    )
                }

                // SH-131: the owner's shared costs of the business.
                composable<Route.SharedCosts> { entry ->
                    val args = entry.toRoute<Route.SharedCosts>()
                    val viewModel: com.evoapps.evoshift.viewmodels.SharedCostsViewModel = diViewModel(args)
                    com.evoapps.evoshift.ui.user.SharedCostsScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                // SH-267: the owner's workplace groups.
                composable<Route.WorkplaceGroups> {
                    com.evoapps.evoshift.ui.user.WorkplaceGroupsScreen(
                        viewModel = diViewModel<com.evoapps.evoshift.viewmodels.WorkplaceGroupsViewModel>(),
                        onNavigateBack = { navController.popBackStack() },
                        onOpenSettings = { groupId -> openRoute(Route.GroupSettings(groupId)) }
                    )
                }

                // SH-269: a group's settings, on the workplace settings screen in group mode.
                composable<Route.GroupSettings> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.GroupSettings>()
                    WorkplaceSettingsScreen(
                        viewModel = diViewModel<Route.GroupSettings, WorkplaceSettingsViewModel>(args),
                        onNavigateBack = { navController.popBackStack() },
                        onNavigateToTemplateEditor = {}
                    )
                }

                composable<Route.Financials> {
                    FinancialsScreen(
                        onNavigateToProfile = openProfile,
                        onNavigateToDailyRecords = { workplaceId, rosterId ->
                            openRoute(Route.DailyRecords(workplaceId, rosterId))
                        },
                        onNavigateToPayroll = { rosterId -> openRoute(Route.Payroll(rosterId)) },
                        // SH-228: the bar's "Statystyki".
                        onNavigateToStatistics = { workplaceId, anchor -> openRoute(Route.Statistics(workplaceId, anchor)) },
                        // SH-257: "Godziny pracy".
                        onNavigateToWorkHours = { workplaceId -> openRoute(Route.WorkHours(workplaceId)) },
                        onCreateNewWorkplace = { openRoute(Route.CreateWorkplace) },
                        onNavigateToWorkplaceSettings = { workplaceId ->
                            openRoute(Route.WorkplaceSettings(workplaceId))
                        },
                        onNavigateBack = if (AppTab.MONEY in tabs) null else { { navController.popBackStack() } }
                    )
                }

                composable<Route.RosterCapacity> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.RosterCapacity>()
                    // SH-89: the month follows the top bar's.
                    RosterMonthHost(
                        entryRosterId = args.rosterId,
                        selection = monthSelection,
                        known = knownRosters,
                        onReplace = { replaceCurrent(Route.RosterCapacity(it.id)) },
                        missing = { month ->
                            NoRosterForMonth(
                                month = month,
                                title = stringResource(Res.string.capacity_title),
                                onBack = { navController.popBackStack() },
                                onCreate = createRosterForMonth?.let { create -> { create(month) } }
                            )
                        }
                    ) {
                        val viewModel: RosterCapacityViewModel = diViewModel(args.rosterId)
                        RosterCapacityScreen(viewModel = viewModel, onNavigateBack = { navController.popBackStack() })
                    }
                }

                composable<Route.Payroll> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.Payroll>()
                    // SH-89: the month follows the top bar's.
                    RosterMonthHost(
                        entryRosterId = args.rosterId,
                        selection = monthSelection,
                        known = knownRosters,
                        onReplace = { replaceCurrent(Route.Payroll(it.id)) },
                        missing = { month ->
                            NoRosterForMonth(month = month, title = stringResource(Res.string.payroll_title), onBack = { navController.popBackStack() })
                        }
                    ) {
                        val viewModel: PayrollViewModel = diViewModel(args.rosterId)
                        PayrollScreen(viewModel = viewModel, onNavigateBack = { navController.popBackStack() })
                    }
                }

                // SH-228: the sales statistics (week, month or a range against the period before or last year).
                composable<Route.Statistics> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.Statistics>()
                    val viewModel: com.evoapps.evoshift.viewmodels.StatisticsViewModel = diViewModel(args)
                    com.evoapps.evoshift.ui.finance.StatisticsScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.DailyRecords> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.DailyRecords>()
                    // SH-89: the month follows the top bar's (another month replaces this entry).
                    RosterMonthHost(
                        entryRosterId = args.rosterId,
                        selection = monthSelection,
                        known = knownRosters,
                        onReplace = { replaceCurrent(Route.DailyRecords(it.workplaceId, it.id)) },
                        missing = { month ->
                            NoRosterForMonth(
                                month = month,
                                title = stringResource(Res.string.daily_records_title),
                                onBack = { navController.popBackStack() }
                            )
                        }
                    ) {
                        val viewModel: DailyRecordsViewModel = diViewModel(args)
                        DailyRecordsScreen(
                            viewModel = viewModel,
                            onNavigateBack = { navController.popBackStack() },
                            // SH-170: "Wpisz utarg" in the to-do opens the entry on its day.
                            entryDate = args.entryDate,
                            // SH-257: the day's hours are confirmed in Godziny pracy.
                            onOpenWorkHours = { date -> openRoute(Route.WorkHours(args.workplaceId, date)) }
                        )
                    }
                }

                // SH-257: confirming the actual working hours day by day.
                composable<Route.WorkHours> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.WorkHours>()
                    val viewModel: com.evoapps.evoshift.viewmodels.WorkHoursViewModel = diViewModel(args)
                    val clockReviewModel = diViewModel<ClockReviewViewModel>()
                    com.evoapps.evoshift.ui.finance.WorkHoursScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() },
                        // SH-134: the day's flagged and unplanned clock-ins.
                        clockReview = { date ->
                            val rosterId = com.evoapps.evoshift.domain.model.RosterIds.of(args.workplaceId, date.take(4).toInt(), date.substring(5, 7).toInt())
                            ClockReviewCard(clockReviewModel, day = Triple(args.workplaceId, rosterId, date), onDark = true)
                        }
                    )
                }

                composable<Route.WorkplaceSettings> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.WorkplaceSettings>()
                    val viewModel: WorkplaceSettingsViewModel = diViewModel(args)
                    WorkplaceSettingsScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() },
                        onNavigateToTemplateEditor = { openRoute(Route.SkeletonEditor(args.workplaceId)) }
                    )
                }

                composable<Route.SkeletonEditor> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.SkeletonEditor>()
                    val viewModel: SkeletonEditorViewModel = diViewModel(args.workplaceId)
                    SkeletonEditorScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() },
                        openShiftTemplates = args.openShiftTemplates
                    )
                }

                composable<Route.EmployeeForm> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.EmployeeForm>()
                    val viewModel: EmployeeFormViewModel = diViewModel(args)
                    EmployeeFormScreen(
                        viewModel = viewModel,
                        onNavigateBack = { navController.popBackStack() },
                        onSeePlans = { navController.navigate(Route.Paywall) { launchSingleTop = true } },
                        onOpenDocuments = { employeeId -> openRoute(Route.StaffDocuments(args.workplaceId, employeeId)) },
                        onOpenTimeline = { employeeId -> openRoute(Route.EmployeeTimeline(args.workplaceId, employeeId)) },
                        onOpenAccess = { employeeId -> openRoute(Route.PersonAccess(args.workplaceId, employeeId)) }
                    )
                }

                // SH-270: roles and one person's access.
                composable<Route.Roles> {
                    com.evoapps.evoshift.ui.user.RolesScreen(
                        viewModel = diViewModel<com.evoapps.evoshift.viewmodels.RolesViewModel>(),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }
                composable<Route.PersonAccess> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.PersonAccess>()
                    com.evoapps.evoshift.ui.user.PersonAccessScreen(
                        viewModel = diViewModel<Route.PersonAccess, com.evoapps.evoshift.viewmodels.PersonAccessViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                // SH-212: a person's timeline (the employee form), or my own (the profile).
                composable<Route.EmployeeTimeline> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.EmployeeTimeline>()
                    com.evoapps.evoshift.ui.user.EmployeeTimelineScreen(
                        viewModel = diViewModel<Route.EmployeeTimeline, com.evoapps.evoshift.viewmodels.EmployeeTimelineViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                // SH-217: importing a month's roster from a spreadsheet.
                composable<Route.RosterImport> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.RosterImport>()
                    com.evoapps.evoshift.ui.roster.RosterImportScreen(
                        viewModel = diViewModel<Route.RosterImport, com.evoapps.evoshift.viewmodels.RosterImportViewModel>(args),
                        onNavigateBack = { navController.popBackStack() },
                        onSeePlans = { navController.navigate(Route.Paywall) { launchSingleTop = true } }
                    )
                }

                // SH-214: importing the team from a spreadsheet.
                composable<Route.StaffImport> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.StaffImport>()
                    com.evoapps.evoshift.ui.user.StaffImportScreen(
                        viewModel = diViewModel<Route.StaffImport, com.evoapps.evoshift.viewmodels.StaffImportViewModel>(args),
                        onNavigateBack = { navController.popBackStack() },
                        onSeePlans = { navController.navigate(Route.Paywall) { launchSingleTop = true } }
                    )
                }

                // SH-122: a person's documents; the workplace's policies.
                composable<Route.StaffDocuments> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.StaffDocuments>()
                    com.evoapps.evoshift.ui.documents.StaffDocumentsScreen(
                        viewModel = diViewModel<Route.StaffDocuments, com.evoapps.evoshift.viewmodels.StaffDocumentsViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                // SH-126: training courses and the OHS training record.
                composable<Route.Courses> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.Courses>()
                    com.evoapps.evoshift.ui.courses.CoursesScreen(
                        viewModel = diViewModel<Route.Courses, com.evoapps.evoshift.viewmodels.CoursesViewModel>(args),
                        onNavigateBack = { navController.popBackStack() },
                        onOpenCourse = { openRoute(Route.TakeCourse(args.workplaceId, it)) },
                        onEditCourse = { openRoute(Route.CourseEditor(args.workplaceId, it)) },
                        onOpenProgress = { openRoute(Route.CourseProgress(args.workplaceId, it)) },
                        onOpenOhs = { openRoute(Route.OhsTraining(args.workplaceId, it)) }
                    )
                }
                composable<Route.CourseEditor> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.CourseEditor>()
                    com.evoapps.evoshift.ui.courses.CourseEditorScreen(
                        viewModel = diViewModel<Route.CourseEditor, com.evoapps.evoshift.viewmodels.CourseEditorViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }
                composable<Route.TakeCourse> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.TakeCourse>()
                    com.evoapps.evoshift.ui.courses.TakeCourseScreen(
                        viewModel = diViewModel<Route.TakeCourse, com.evoapps.evoshift.viewmodels.TakeCourseViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }
                composable<Route.CourseProgress> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.CourseProgress>()
                    com.evoapps.evoshift.ui.courses.CourseProgressScreen(
                        viewModel = diViewModel<Route.CourseProgress, com.evoapps.evoshift.viewmodels.CourseProgressViewModel>(args),
                        onNavigateBack = { navController.popBackStack() },
                        onOpenOhs = { openRoute(Route.OhsTraining(args.workplaceId, it)) }
                    )
                }
                composable<Route.OhsTraining> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.OhsTraining>()
                    com.evoapps.evoshift.ui.courses.OhsRecordScreen(
                        viewModel = diViewModel<Route.OhsTraining, com.evoapps.evoshift.viewmodels.OhsRecordViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.Policies> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.Policies>()
                    com.evoapps.evoshift.ui.documents.PoliciesScreen(
                        viewModel = diViewModel<Route.Policies, com.evoapps.evoshift.viewmodels.PoliciesViewModel>(args),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                composable<Route.RosterSkeleton> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.RosterSkeleton>()
                    // SH-89: follows the app-wide month like the roster builder.
                    RosterMonthHost(
                        entryRosterId = args.rosterId,
                        selection = monthSelection,
                        known = knownRosters,
                        onReplace = { openRoster(it) },
                        missing = { month ->
                            NoRosterForMonth(
                                month = month,
                                onBack = { navController.popBackStack() },
                                onCreate = createRosterForMonth?.let { create -> { create(month) } }
                            )
                        }
                    ) {
                        val viewModel: RosterSkeletonViewModel = diViewModel(args.rosterId)
                        RosterSkeletonScreen(
                            viewModel = viewModel,
                            onNavigateBack = { navController.popBackStack() },
                            onFinished = {
                                navController.navigate(Route.RosterDetail(args.rosterId)) {
                                    popUpTo<Route.RosterSkeleton> { inclusive = true }
                                    launchSingleTop = true
                                }
                            }
                        )
                    }
                }

                composable<Route.Notifications> {
                    NotificationsScreen(
                        viewModel = notificationsViewModel,
                        onNavigateBack = { navController.popBackStack() },
                        onOpen = { route -> openRoute(route) }
                    )
                }

                // SH-125: hiring - the posts (Team → Hiring), a post's editor, its applicants.
                composable<Route.Hiring> {
                    com.evoapps.evoshift.ui.hiring.HiringScreen(
                        viewModel = diViewModel<com.evoapps.evoshift.viewmodels.HiringViewModel>(),
                        onNavigateBack = { navController.popBackStack() },
                        onOpenApplicants = { postId -> openRoute(Route.Applicants(postId)) },
                        onEditPost = { postId -> openRoute(Route.JobPostEditor(postId)) }
                    )
                }
                composable<Route.JobPostEditor> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.JobPostEditor>()
                    val sharer: com.evoapps.evoshift.util.TextSharer by rememberInstance()
                    com.evoapps.evoshift.ui.hiring.JobPostEditorScreen(
                        viewModel = diViewModel<Route.JobPostEditor, com.evoapps.evoshift.viewmodels.JobPostEditorViewModel>(args),
                        onNavigateBack = { navController.popBackStack() },
                        share = { text, subject -> runCatching { sharer.share(text, subject) }.getOrDefault(false) }
                    )
                }
                composable<Route.Applicants> { backStackEntry ->
                    val args = backStackEntry.toRoute<Route.Applicants>()
                    com.evoapps.evoshift.ui.hiring.ApplicantsScreen(
                        viewModel = diViewModel<Route.Applicants, com.evoapps.evoshift.viewmodels.ApplicantsViewModel>(args),
                        onNavigateBack = { navController.popBackStack() },
                        onHire = { workplaceId, postId, applicationId ->
                            openRoute(Route.EmployeeForm(workplaceId, null, postId, applicationId))
                        }
                    )
                }

                // SH-239: "Recommend EVoShift to another employer" (More, the card after joining a team).
                composable<Route.Recommend> {
                    val sharer: com.evoapps.evoshift.util.TextSharer by rememberInstance()
                    com.evoapps.evoshift.ui.growth.RecommendScreen(
                        viewModel = diViewModel<com.evoapps.evoshift.viewmodels.RecommendViewModel>(),
                        onNavigateBack = { navController.popBackStack() },
                        share = { text, subject -> runCatching { sharer.share(text, subject) }.getOrDefault(false) }
                    )
                }

                // SH-118: the team's posts (from More, or a post's notification).
                composable<Route.Announcements> {
                    com.evoapps.evoshift.ui.announcements.AnnouncementsScreen(
                        viewModel = diViewModel<com.evoapps.evoshift.viewmodels.AnnouncementsViewModel>(),
                        onNavigateBack = { navController.popBackStack() }
                    )
                }

                // A tab's root has no back arrow (back returns home); reached from More, it has.
                composable<Route.Absences> {
                    val viewModel: AbsencesViewModel = diViewModel()
                    AbsencesScreen(
                        viewModel = viewModel,
                        onNavigateBack = if (AppTab.ABSENCES in tabs) null else { { navController.popBackStack() } }
                    )
                }

                composable<Route.Requests> {
                    val viewModel: RequestsViewModel = diViewModel()
                    RequestsScreen(
                        viewModel = viewModel,
                        onNavigateBack = if (AppTab.REQUESTS in tabs) null else { { navController.popBackStack() } }
                    )
                }

                composable<Route.More> {
                    // SH-210: recruiters who are not managers reach hiring from here.
                    val recruiting by diViewModel<com.evoapps.evoshift.viewmodels.RecruitingViewModel>().recruiting.collectAsStateWithLifecycle()
                    MoreScreen(
                        // SH-247: null until the profile is read (the header's placeholder, not "Profile" first).
                        userName = dashboardState.userName.takeIf { dashboardState.userId.isNotEmpty() },
                        workplaceName = workplaceName,
                        entries = moreEntriesFor(capabilities, tabs, hasWorkplace = workplaceId != null, recruiting = recruiting),
                        unreadNotifications = notificationsState.unreadCount,
                        pendingRequests = pendingRequests,
                        onEntry = { entry ->
                            when (entry) {
                                MoreEntry.SWITCH_WORKPLACE -> contextSwitcher.open()
                                MoreEntry.NOTIFICATIONS, MoreEntry.PROFILE ->
                                    entry.route(workplaceId)?.let { navController.openOnce(it) }
                                else -> entry.route(workplaceId)?.let { openRoute(it) }
                            }
                        }
                    )
                }
            }
            SaveNoticesHost(pendingSaves, Modifier.align(Alignment.BottomCenter))
            }
            }
            }
            // SH-168: no connection: the changes wait in Firestore's queue, and the app says so.
            val planEndedShown = gate == SessionGate.READY && chrome != NavChrome.NONE && dashboardState.capabilities.isReadOnly
            // SH-220: the owner's team outgrew the plan (never blocked): the next tier is proposed.
            // Only owners get the view model, as it identifies the store SDK.
            val overPlanViewModel: OverPlanViewModel? =
                if (gate == SessionGate.READY && dashboardState.capabilities.shows(Gate.PLAN)) diViewModel() else null
            val overPlan = overPlanViewModel?.state?.collectAsStateWithLifecycle()?.value
            val overPlanShown = overPlan != null && chrome != NavChrome.NONE && !planEndedShown &&
                overPlan.isShown(com.evoapps.evoshift.domain.util.AppClock.now())
            com.evoapps.evoshift.widgets.ConnectivityBanner(
                notice = connectionNotice,
                modifier = if (chrome != NavChrome.BAR && !planEndedShown && !overPlanShown) Modifier.navigationBarsPadding() else Modifier
            )
            MotionVisibility(overPlanShown) {
                if (overPlan != null && overPlanViewModel != null) {
                    val reminds = overPlan.remindsRenewal(com.evoapps.evoshift.domain.util.AppClock.now())
                    OverPlanBanner(
                        state = overPlan,
                        remindsRenewal = reminds,
                        onUpgrade = overPlanViewModel::upgrade,
                        onDismiss = overPlanViewModel::dismiss.takeUnless { reminds },
                        modifier = if (chrome == NavChrome.RAIL) Modifier.navigationBarsPadding() else Modifier
                    )
                }
            }
            // Read-only after the plan ended (SH-65): every main screen says so, above the bar;
            // the owner can choose a plan from it.
            // SH-158: it unfolds above the bar (and folds away once a plan is chosen).
            MotionVisibility(planEndedShown) {
                PlanEndedBanner(
                    onChoosePlan = { navController.navigate(Route.Paywall) { launchSingleTop = true } }
                        .takeIf { dashboardState.capabilities.shows(Gate.PLAN) },
                    modifier = if (chrome == NavChrome.RAIL) Modifier.navigationBarsPadding() else Modifier
                )
            }
            AnimatedVisibility(
                visible = chrome == NavChrome.BAR,
                enter = expandVertically(expandFrom = Alignment.Top),
                exit = shrinkVertically(shrinkTowards = Alignment.Top)
            ) {
                AppNavigationBar(
                    tabs = tabs,
                    selected = selected,
                    badges = badges,
                    onSelect = { navController.selectTab(it, tabs) }
                )
            }
            }
            }
        }
    }
    }
}

/**
 * The login screen's top while an invitation waits for the account. SH-245: it is drawn on the
 * brand gradient, so its text takes the gradient's roles (the base's navy vanished there).
 */
@Composable
private fun PendingInvitationHeader() {
    val on = com.evoapps.evoshift.widgets.LocalOnColours.current
    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        Image(
            painter = painterResource(Res.drawable.app_logo),
            contentDescription = "EVoShift",
            modifier = Modifier.size(96.dp)
        )
        Spacer(Modifier.height(16.dp))
        Text(
            stringResource(Res.string.join_team_invited),
            style = MaterialTheme.typography.titleLarge,
            fontWeight = FontWeight.Bold,
            color = on.accent,
            textAlign = TextAlign.Center
        )
        Text(
            stringResource(Res.string.join_pending_hint),
            style = MaterialTheme.typography.bodyMedium,
            color = on.onSurfaceVariant,
            textAlign = TextAlign.Center,
            modifier = Modifier.padding(top = 4.dp)
        )
    }
}
